let IDCode = {
  ID: 'A', //身份证
  Passport: 'B', //护照          Passport
  HMPassport: 'D', //港澳通行证     Hongkong Macao
  TPassport: 'E', //台胞证        Taiwan
  OPPassport: 'L', //其他个人证件   other personal
};

let contactType = {
  ContactTypeAdult: 0, //成人
  ContactTypeChildren: 1, //儿童
  ContactTypeStudent: 2, //全日制学生
  ContactTypeSoldier: 3, //现役军人
  ContactTypeDisabledPeople: 4, //残疾人
  ContactTypeDisableSoldier: 5, //伤残军人(警察)
  ContactTypeSnow: 6, //冰雪令
};

const all = {
  ID: [
    {
      name: '身份证',
      value: IDCode.ID,
    },
    {
      name: '护照',
      value: IDCode.Passport,
    },
    {
      name: '港澳居民通行证',
      value: IDCode.HMPassport,
    },
    {
      name: '台胞证',
      value: IDCode.TPassport,
    },
    // {name:"军官证",value:"G"},
    // {name:"学生证",value:"K"},
    // {name:"其他(个人)",value:IDCode.OPPassport}
  ],
  IDCode: IDCode,
  IDNameFromValue: function(value) {
    if (!value) {
      return '';
    }
    let name = '';
    if (value == IDCode.ID) {
      name = '身份证';
    } else if (value == IDCode.Passport) {
      name = '护照';
    } else if (value == IDCode.HMPassport) {
      name = '港澳居民通行证';
    } else if (value == IDCode.TPassport) {
      name = '台胞证';
    } else if (value == 'G') {
      name = '军官证';
    } else if (value == 'K') {
      name = '学生证';
    } else if (value == IDCode.OPPassport) {
      name = '其他(个人)';
    } else {
      name = '其他';
    }
    return name;
  },
  gender: [
    {
      name: '男',
      value: 1,
    },
    {
      name: '女',
      value: 2,
    },
  ],
  TouristsType: [
    {
      name: '成人',
      value: contactType.ContactTypeAdult,
    },
    {
      name: '儿童',
      value: contactType.ContactTypeChildren,
    },
  ],
  halfPriceTouristsType: [
    {
      name: '全日制学生',
      value: contactType.ContactTypeStudent,
    },
    {
      name: '现役军人',
      value: contactType.ContactTypeSoldier,
    },
    {
      name: '冰雪令',
      value: contactType.ContactTypeSnow,
    },
  ],
  freePriceTouristsType: [
    {
      name: '残疾人',
      value: contactType.ContactTypeDisabledPeople,
    },
    {
      name: '伤残军人(警察)',
      value: contactType.ContactTypeDisableSoldier,
    },
    {
      name: '冰雪令',
      value: contactType.ContactTypeSnow,
    },
  ],
  TouristsNameWithType: function(type) {
    let name = '';
    switch (type) {
      case contactType.ContactTypeAdult:
        name = '成人';
        break;
      case contactType.ContactTypeChildren:
        name = '儿童';
        break;
      case contactType.ContactTypeStudent:
        name = '全日制学生';
        break;
      case contactType.ContactTypeSoldier:
        name = '现役军人';
        break;
      case contactType.ContactTypeDisabledPeople:
        name = '残疾人';
        break;
      case contactType.ContactTypeDisableSoldier:
        name = '伤残军人(警察)';
        break;
      case contactType.ContactTypeSnow:
        name = '冰雪令';
        break;
      default:
        name = '';
        break;
    }
    return name;
  },
  ticketType: {
    fullPriceTicketType: 1, //全价门票
    halfPriceTicketType: 2, //半价门票
    freeTicketType: 3, //免费门票
    busTicketType: 4, //环保车票
  },
  placeType: {
    //长白山景区
    placeTypeCBS: 1,
    //其它景区
    placeTypeOther: 2,
  },
  contactType: contactType,
};

export default all;
